import { Router } from "@angular/router";
import { Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ComponentBase } from "../base/component-base";
import { ApplicantService } from "../service/applicant.service";
import { CookiesLocalService } from "../service/cookies-local.service";
import { UtilService } from "../service/util.service";
import { ToastrService } from "ngx-toastr";
import { BehaviorModelChangeService } from "../service/behavior-model-change.service.service";
import { Configuration } from "../configuration";

@Component({
  selector: "app-choose-campus",
  templateUrl: "./choose-campus.component.html",
  styleUrls: ["./choose-campus.component.css"],
})
export class ChooseCampusComponent extends ComponentBase implements OnInit {
  campusFormGroup: FormGroup;
  campus: any[];
  programmes: any[];
  campusSelected: boolean;
  campusData: any;
  entryTypes = [
    { Name: "Direct", Id: 1 },
    { Name: "Topup", Id: 2 },
  ];
  constructor(
    private fb: FormBuilder,
    applicantService: ApplicantService,
    cookieLocal: CookiesLocalService,
    private router: Router,
    private utilService: UtilService,
    private toastr: ToastrService,
    behaviorModelChangeService: BehaviorModelChangeService
  ) {
    super(applicantService, cookieLocal, behaviorModelChangeService);
  }

  continueButtonText = "Save & Continue";
  ngOnInit(): void {
    this.campusFormGroup = this.fb.group({
      CampusId: [this.applicantData.CampusId, Validators.required],
      EntryTypeId: [this.applicantData.EntryTypeId ?? 1, Validators.required],
    });
    this.utilService.getCampus().subscribe(
      (data) => {
        this.campus = data;
        this.showLoadingIndicator = false;
      },
      (error) => {}
    );
  }
  onChangeCampus() {
    this.campusSelected = !this.campusSelected;
  }
  onCampusChanged(event) {
    this.showLoadingIndicator = true;
    let campusId = this.campusFormGroup.get("CampusId").value;
    const isPostgraduateStudent = this.isPostgraduateStudent();
    this.utilService
      .getUnderGraduateProgrammesForAdmissionByCampusId(
        campusId,
        isPostgraduateStudent
      )
      .subscribe(
        (data) => {
          let programData = data;

          if (!isPostgraduateStudent) {
            if (this.isCertificateStudent()) {
              programData = programData.filter((s) => s.CertificateId == 2);
            } else if (this.isDiplomaStudent()) {
              programData = programData.filter((s) => s.CertificateId == 3);
            } else {
              programData = programData.filter((s) => s.CertificateId === 1);
            }
          }
          this.programmes = programData;

          this.showLoadingIndicator = false;
        },
        (error) => {
          this.showLoadingIndicator = false;
        }
      );
  }

  goToNext(form: any) {
    const data = this.campusFormGroup.value;
    const model = this.cookieLocal.getApplicantData();
    model.CampusId = data.CampusId;
    model.EntryTypeId = data.EntryTypeId;
    this.applicantService.savePersonalData(model).subscribe(
      (val) => {
        this.cookieLocal.getRefreshedApplicantData(model);
        this.router.navigate(["/applicant/info/upload-image"]);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  goToPrevious(form: any) {
    this.router.navigate(["/applicant/info/notices"]);
  }
}
